(() => {
  if (customElements.get('bp-editorial')) return;
  class BPEditorial extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.desktop = matchMedia('(min-width: 750px)');
      this.media = [...this.querySelectorAll('[data-bp-motion]')];
      this.refresh = this.refresh.bind(this);
      this.schedule = this.schedule.bind(this);
      this.reduced.addEventListener('change', this.refresh, {signal:this.controller.signal});
      this.desktop.addEventListener('change', this.refresh, {signal:this.controller.signal});
      this.refresh();
    }
    stop() {
      this.observer?.disconnect();
      this.scrollController?.abort();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.reveal?.cancel();
      this.media.forEach(el => el.style.removeProperty('--bp-motion'));
    }
    refresh() {
      this.stop();
      if (this.reduced.matches) return;
      const inEditor = this.dataset.editor === 'true' || window.Shopify?.designMode;
      const mode = this.dataset.animation;
      if (mode === 'reveal' && !inEditor && !this.revealed && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.revealed = true;
          this.observer.disconnect();
          this.reveal = this.querySelector('.bp-ed__content').animate([
            {opacity:0,transform:'translateY(20px)'},
            {opacity:1,transform:'translateY(0)'}
          ], {duration:550,easing:'ease-out'});
        }, {threshold:0});
        this.observer.observe(this);
      }
      if (mode !== 'parallax' || this.dataset.parallax !== 'true' || !this.desktop.matches) return;
      const requested = Number.parseFloat(this.dataset.parallaxIntensity);
      this.intensity = Number.isFinite(requested) ? Math.max(0.5, Math.min(4, requested)) : 1;
      this.scrollController = new AbortController();
      const options = {passive:true,signal:this.scrollController.signal};
      window.addEventListener('scroll',this.schedule,options);
      window.addEventListener('resize',this.schedule,options);
      this.schedule();
    }
    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        const rect = this.getBoundingClientRect();
        if (rect.bottom < -100 || rect.top > innerHeight + 100) return;
        const progress = Math.max(-1,Math.min(1,(innerHeight/2-rect.top-rect.height/2)/(innerHeight/2+rect.height/2)));
        this.media.forEach((el,index) => {
          el.style.setProperty('--bp-motion', `${(progress * (index % 2 ? -12 : 12) * this.intensity).toFixed(2)}px`);
        });
      });
    }
    disconnectedCallback() {
      this.stop();
      this.controller?.abort();
    }
  }
  customElements.define('bp-editorial',BPEditorial);
})();
